import { combineReducers } from "redux";
import  { ForgotPasswordReducer, LoginReducer, ResetExpiryPasswordReducer, ResetPasswordReducer, UpdatePasswordReducer } from "../LoginState/LoginReducer";
import { EditUserReducer, UserByIdReducer, UserReducer, UsersListReducer, UsersListWithOutPagination } from "../UserState/UserReducer";
import { ClientReducer, ClientsListReducer,EditClientReducer,
    ClientByIdReducer,
    ClientsListWithOutPagination} from "../ClientState/ClientReducer";
import {EditProjectReducer, ProjectReducer,ProjectsListReducer,ProjectByIdReducer, ProjectsByIdReducer, ProjectsListWithOutPagination} from "../ProjectState/ProjectReducer"
import {DownloadFileReducer, FileReducer, UploadFileReducer} from "../FileState/uploadFileReducer";
import { AddTimesheetReducer, TimeSheetByProjectIdReducer, TimeSheetByProjectIdReducerForUserPage ,EditTimesheetsReducer, GetTimesheetByIdReducer, TimesheetsActionReducer, GenerateInvoiceReducer, DownloadInvoiceReducer, DownloadTimeSheetReducer, TimesheetListReducer, TimesheetAppReducer, TimesheetModalReducer, DownloadFileByIdReducer } from "../TimeSheetState/TimeSheetReducer";
import { GetCoverImageReducer, GetProfilePictureReducer, ProfileReducer, UpdateProfileUserReducer, UploadCoverImageReducer, UploadProfilePictureReducer } from "../ProfileState/ProfileReducer";
import { DocumentUploadReducer, EmpStatusReducer, GetDocTypesReducer, GetEmpStatusReducer } from "../EmployeeStatusState/empStatusReducer";
import { BudgetReportReducer, GenerateReportReducer, ReportsReducer } from "../ReportsState/ReportsReducer";
import { AppConfigHoverReducer, AppConfigReducer } from "../AppconifgStage/AppconfigReducer";
import {DashboardListReducer, EmpDashboardListReducer, EmpDashboardMonthlyHoursReducer ,EmpWishesReducer,TimesheetCountReducer, WeeklyEfficiencyReducer} from "../DashboardState/dashBoardReducer";
import { InvoiceListReducer, InvoicePaymentDateReducer, ReGenerateInvoicePDFReducer } from "../InvoiceState/InvoiceReducer";
import { AlertListReducer, SideNavReducer } from "../AlertsState/AlertsReducer";
import { TimeOffListReducer, GetTimeOffByIdReducer, UpdateTimeOffReducer, CancelTimeOffReducer, RequestTimeOffRequestReducer, GetAllTimeOffRequestsUsingUserIdReducer } from "../TimeOffState/TimeOffReducer";
const rootReducer = combineReducers({
    LoginReducer,
    TimeOffListReducer,
    ProfileReducer,
    ForgotPasswordReducer,
    ResetPasswordReducer,
    UpdatePasswordReducer,
    UserReducer,
    UsersListReducer,
    UserByIdReducer,
    EditUserReducer,
    ClientReducer,
    ClientsListReducer,
    EditClientReducer,
    ClientByIdReducer,
    ProjectReducer,
    ProjectsListReducer,
    ProjectsByIdReducer,
    TimeSheetByProjectIdReducer,
    TimeSheetByProjectIdReducerForUserPage,
    AddTimesheetReducer,
    EditTimesheetsReducer,
    GetTimesheetByIdReducer,
    EditProjectReducer,
    ProjectByIdReducer,
    UploadFileReducer,
    UsersListWithOutPagination,
    ClientsListWithOutPagination,
    ResetExpiryPasswordReducer,
    TimesheetsActionReducer,
    FileReducer,
    EmpStatusReducer,
    GetEmpStatusReducer,
    // BackgroundImageReducer,
    ReportsReducer,
    DownloadFileReducer,
    ProjectsListWithOutPagination,
    GenerateReportReducer,
    BudgetReportReducer,
    GenerateInvoiceReducer,
    GetDocTypesReducer,
    DocumentUploadReducer,
    AppConfigReducer,
    AppConfigHoverReducer,
    DownloadInvoiceReducer,
    DashboardListReducer,
    DownloadTimeSheetReducer,
    UpdateProfileUserReducer,
    InvoiceListReducer,
    TimesheetListReducer,
    TimesheetAppReducer,
    ReGenerateInvoicePDFReducer,
    InvoicePaymentDateReducer,
    EmpDashboardListReducer,
    AlertListReducer,
    EmpDashboardMonthlyHoursReducer,
    TimesheetCountReducer,
    EmpWishesReducer,
    UploadProfilePictureReducer,
    GetProfilePictureReducer,
    WeeklyEfficiencyReducer,
    UploadCoverImageReducer,
    GetCoverImageReducer,
    SideNavReducer,
    TimesheetModalReducer,
    DownloadFileByIdReducer,
    
    GetTimeOffByIdReducer,
    UpdateTimeOffReducer,
    CancelTimeOffReducer,
    RequestTimeOffRequestReducer,
    GetAllTimeOffRequestsUsingUserIdReducer

    });
const rootR = (state, action) => rootReducer(state, action);
export default rootR;
